/**
 * HudFrame — corner-bracket frame component for HUD/cyber-elegant containers.
 * Pure visual; wraps any children with 4 cyan brackets and an optional border tint.
 */
export default function HudFrame({
    children,
    bracketColor = "var(--tca-cyan-core)",
    bracketSize = 14,
    borderTint = "rgba(0, 224, 232, 0.10)",
    className = "",
    innerClassName = "",
    ...rest
}) {
    const Bracket = ({ corner }) => {
        const positions = {
            tl: { top: 0, left: 0, borderTop: `1px solid ${bracketColor}`, borderLeft: `1px solid ${bracketColor}` },
            tr: { top: 0, right: 0, borderTop: `1px solid ${bracketColor}`, borderRight: `1px solid ${bracketColor}` },
            bl: { bottom: 0, left: 0, borderBottom: `1px solid ${bracketColor}`, borderLeft: `1px solid ${bracketColor}` },
            br: { bottom: 0, right: 0, borderBottom: `1px solid ${bracketColor}`, borderRight: `1px solid ${bracketColor}` },
        };
        return (
            <span
                aria-hidden="true"
                className="absolute pointer-events-none"
                style={{
                    width: bracketSize,
                    height: bracketSize,
                    ...positions[corner],
                    boxShadow: `0 0 6px ${bracketColor}`,
                }}
            />
        );
    };

    return (
        <div
            className={`relative ${className}`}
            style={{ border: `1px solid ${borderTint}` }}
            {...rest}
        >
            <Bracket corner="tl" />
            <Bracket corner="tr" />
            <Bracket corner="bl" />
            <Bracket corner="br" />
            <div className={innerClassName}>{children}</div>
        </div>
    );
}
